module.exports = __webpack_public_path__ + "img/ALERTDUEDATE.e55ce3c2.png";